import Component from '../component';

export default class Slideshow extends Component {
    constructor(...args) {
        super(...args);

        this._retrieveDom();
    }

    /**
     * init slideShow
     */
    init() {
        this._createSlider();
        this._initSliderEvents();
        this._setControls();
        this._setSlideIndex();

    }

    /**
     * Create Flickity slideshow from dom component
     * @private
     */
    _createSlider() {
        // initialize flickity slider
        this.flktySlider = new Flickity( this.dom.component, {
            // options...
            cellSelector: '.flexible-slideshow-slide',
            adaptiveHeight: true,
            prevNextButtons: false,
            pageDots: false
        });
    }

    /**
     * Get dom slideshow elements
     * @private
     */
    _retrieveDom() {
        // Navigation buttons
        this.dom.btnPrev = this.dom.component.querySelector('.prev');
        this.dom.btnNext = this.dom.component.querySelector('.next');

        // Slider index
        this.dom.indexIndicWrapper = this.dom.component.querySelector('.index-indic-wrapper');
        this.dom.indexIndic = this.dom.component.querySelector('.index-indic');
        this.dom.sliderLenght = this.dom.component.querySelector('.length-indic');
    }

    /**
     * Set slideshow control buttons
     * @private
     */
    _setControls() {
        // previous
        if( this.dom.btnPrev ) {
            this.dom.btnPrev.addEventListener( 'click', () => {
                this.flktySlider.previous(true);
            });
        }

        // next
        if( this.dom.btnNext ) {
            this.dom.btnNext.addEventListener( 'click', () => {
                this.flktySlider.next(true);
            });
        }
    }

    /**
     * Fill slideshow index indicator
     * @private
     */
    _setSlideIndex() {
        // set slides length
        const slideLength = this.flktySlider.slides.length;

        if( this.dom.sliderLenght )
            this.dom.sliderLenght.textContent = slideLength < 10 ? '0' + slideLength : slideLength;

        if( this.flktySlider.selectedIndex )
            this._updateSlideIndex(this.flktySlider.selectedIndex);
    }

    /**
     * Update slide index in index indic
     * @param {int} index - Target Slide index
     * @private
     */
    _updateSlideIndex(index) {
        // Clone and add new index
        index += 1;
        const newIndexIndic = this.dom.indexIndic.cloneNode();
        newIndexIndic.textContent  = index < 10 ? '0' + index : index;
        this.dom.indexIndicWrapper.appendChild(newIndexIndic);

        // animate new tl
        const tl = new TimelineMax();
        tl.set(newIndexIndic, {y: '100%'})
            .to(newIndexIndic, 0.6, {y: '0%', ease: Power3.easeInOut})
            .to(this.dom.indexIndic, 0.6, {y: '-100%', ease: Power3.easeInOut}, 0)
            .add(() => {
                // remove old
                this.dom.indexIndicWrapper.removeChild(this.dom.indexIndic);
                // set new index element tu current
                this.dom.indexIndic = newIndexIndic;
            })
    }

    /**
     * init slideshow events
     * @private
     */
    _initSliderEvents() {
        this.flktySlider.on( 'change', (index) => this._handleSlideChange(index));
    }

    /**
     * handle slideshow on slide change
     * @param {int} index - Target Slide index
     * @private
     */
    _handleSlideChange(index) {
        this._updateSlideIndex(index);
    }

}



// WEBPACK FOOTER //
// ./src/js/components/slideshow/slideshow.js